import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";
import "./NurseOut.scss";

import {items as itemsInit} from "./config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
import {TabsProps} from "antd";
const NurseOut: React.FC = () => {
  document.title = "Điều dưỡng ngoại trú";
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const idPhieu = useAppSelector(state => state.nurseOut.idPhieu);
  const activeKey = useAppSelector(state => state.common.activeTab);
  useEffect(() => {
    itemsInit[1].disabled = idPhieu == null;
    itemsInit[2].disabled = idPhieu == null;
    setItems([...itemsInit]);
  }, [idPhieu]);
  return (
    <div className="nurse-out page">
      <div className="main">
        <Tabs items={items} activeKey={activeKey} />
      </div>
    </div>
  );
};
export default NurseOut;
